import {
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction, useEffect } from "react";
import { validEmailRegex } from "../../utils/regex";
import HeaderForgotPassword from "./HeaderForgotPassword";

interface EmailResetProps {
    setEmail: (email: string) => void;
    setIsEmailFormValid: Dispatch<SetStateAction<boolean>>;
    email: string;
}

const EmailReset = ({ email, setEmail, setIsEmailFormValid }: EmailResetProps) => {
    const { t } = useTranslation();
    useEffect(() => {
        setIsEmailFormValid(email !== "" && validEmailRegex.test(email))
    }, [email])
    return (
        <HeaderForgotPassword title={t("passwordReset.title")}>
            <TextField
                margin="normal"
                required
                fullWidth
                size="medium"
                id="email"
                type="email"
                label={t("header.email")}
                autoComplete="off"
                autoFocus
                variant="outlined"
                sx={{
                    background: "white"
                }}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                slotProps={{
                    input: {
                        startAdornment: <InputAdornment position="start"><IconButton></IconButton>{<EmailIcon sx={{ fontSize: 15 }} />}</InputAdornment>,
                    }
                }}

            />
            <Typography align="center" sx={{ mt: 2, fontSize: 13 }}>
                {t("passwordReset.enterEmailMessage")}
            </Typography>
        </HeaderForgotPassword>

    );
};

export default EmailReset;